import api from './api'

export interface PlatformAnalytics {
  metrics: {
    totalQuotes: number
    totalOrders: number
    conversionRate: number
    averageOrderValueUsd: number
    totalUsers: number
    newUsers: number
    totalOffers: number
    totalRevenueUsd: number
  }
  series: { label: string; quotes: number; orders: number }[]
  topTenants: { name: string; quotes: number; orders: number }[]
  modalityBreakdown: { name: string; count: number; percentage: number }[]
  topDestinations: { country: string; quotes: number }[]
}

export async function getPlatformAnalytics(range: string): Promise<PlatformAnalytics> {
  const res = await api.get<PlatformAnalytics>(`/master/analytics?range=${encodeURIComponent(range)}`)
  return res.data
}
